<template>
  <div>
    <!--EDITAR-->

    <ed-modal
      title="Novo Funcionário"
      :modal="showFormEdit"
      :isModal="false"
      :onSave="this.salvar"
      width="70%"
    >
      <div slot="modal-content">
        <ed-form :model="formData">
          <ed-input-auto-complete
            v-if="formData.id == 0"
            class="text-left col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            label="Funcionário"
            placeholder="Digite o nome do trabalhador(a)"
            v-model="formData.id_funcionario"
            :items="lstFuncionario"
            :loading="loadingFuncionario"
            @search="getFuncionario"
            @input="setFuncionario"
            clearable
            required
            itemText="funcionario"
          />

          <ed-input-text
            v-else-if="formData.funcionario && formData.id > 0"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
            label="Trabalhador(a)"
            type="text"
            v-model="formData.funcionario.nome"
            required
            disabled
          />

          <ed-input-text-area
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
            label="Descrição das Atividades do funcionário"
            type="text"
            v-model="formData.descricao"
            maxlength="999"
            required
          />
        </ed-form>
      </div>
    </ed-modal>

    <ed-table
      registerName="Inserir Novo Funcionário"
      :onRegister="onRegister"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getLtcatFuncionario"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
    />
  </div>
</template>

<script>
import EdTable from "common/table";
import EdModal from "common/modal";
import {
  EdForm,
  EdInputAutoComplete,
  EdInputText,
  EdInputTextArea,
} from "template";

export default {
  name: "ltcat.ghe.funcao",
  components: {
    EdTable,
    EdModal,
    EdForm,
    EdInputAutoComplete,
    EdInputText,
    EdInputTextArea,
  },
  mixins: [],
  props: {
    parent: {
      type: Object,
      default: null,
    },
    ltcat: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.formData.id"() {
      this.getLtcatFuncionario();
      this.getFuncionario();
      this.getLtcatFuncao()
    },
    "parent.formData.funcoes"() {},
    "$store.state.ltcat.data.id"() {},
    "$store.state.common.event"() {
      this.getLtcatFuncao();
    },
  },
  data() {
    return {
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_funcionario: null,
        descricao: null,
        usuario: null,
        updated_at: null,
      },
      tableHead: [
        {
          key: "cpf",
          sortable: true,
          width: "80px",
          label: "CPF",
        },
        {
          key: "nome",
          sortable: true,
          label: "Nome",
        },
        {
          key: "funcao",
          sortable: true,
          label: "Função",
        },
        {
          key: "descricao",
          sortable: true,
          show_colapse: true,
          label: "Descrição Atividades",
        },

        {
          key: "updated_at",
          width: "180px",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      funcionario: null,
      lstFuncionario: [],
      lstFuncoes:[],
      loadingFuncionario: false,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.getLtcatFuncionario();
    this.getLtcatFuncao()
    this.getFuncionario();
  },

  methods: {
    setFuncionario() {
      if (this.lstFuncoes) {
        let self = this;
        let funcionario = this.lstFuncionario.find(
          (c) => c.id == self.formData.id_funcionario
        );
        let funcao = this.lstFuncoes.find(
          (c) => c.funcao && funcionario && c.funcao.id == funcionario.id_funcao
        );

        if (funcao && funcao.descricao) {
          this.formData.descricao = funcao.descricao;
        } 
        else if(funcionario && funcionario.funcao){
          this.formData.descricao = funcionario.funcao.descricao;
        }
        else {
          this.formData.descricao = null;
        }
      }
    },

    onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_funcionario: null,
        descricao: null,
        usuario: null,
        updated_at: null,
      };
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit(data) {
      this.formData = {
        id: data.id,
        id_ghe: this.parent.formData.id,
        id_funcionario: data.funcionario.id,
        funcionario: data.funcionario,
        descricao: data.descricao,
        usuario: data.usuario,
        updated_at: data.updated_at,
      };

      console.log("formData", this.formData);
      this.showFormEdit = !this.showFormEdit;
    },

    onDelete: function (data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        self.loadingEditAll = true;
        self.loadingTable = true;

        this.$root.$request
          .post(
            "/ltcat/ghe/funcionario/" + this.parent.formData.id + "/deletar",
            {
              ids: data,
            }
          )
          .then((result) => {
            self.loadingEditAll = false;

            if (result.status == 200) {
              self.getLtcatFuncionario();
              self.$root.$dialog.alert("Registo excluido com sucesso");
            }
          });
      });
    },

    getFuncionario(_search) {
      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.$root.$request
        .get("/empresa/funcionario/" + this.ltcat.id_emp, { search: _search })
        .then((result) => {
          this.loadingFuncionario = false;
          if (result.status == 200) {
            this.lstFuncionario = result.data.data;
          }
        });
    },

    getLtcatFuncionario(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.$root.$request
        .get("ltcat/ghe/funcionario/" + this.parent.formData.id, {
          search: _search,
          page: _page,
          pagination: _pagination,
        })
        .then((result) => {
          this.response = result;
          this.loadingTable = false;

          if (result.status == 200) {
            var data = result.data.data,
              tableData = [],
              self = this,
              pagination = result.data;

            for (var i = 0; i < data.length; i++) {
              var item = {
                cpf: data[i].funcionario.cpf,
                nome: data[i].funcionario.nome,
                funcao: data[i].funcionario.funcao
                  ? data[i].funcionario.funcao.nome
                  : "",
                descricao: data[i].descricao,
                updated_at: this.$utilidade.toDate(data[i].updated_at),
                _data: data[i],
                options: {
                  disable_delete: !this.$root.$session.validarPermissao(567),
                },
                buttons: [],
              };
              tableData.push(item);
            }

            this.pagination = pagination;
            this.tableData = tableData;
          }
        });
    },

    getLtcatFuncao() {
      this.lstFuncoes = []
       this.$root.$request.get("ltcat/ghe/funcao/" + this.parent.formData.id).then((result) => {
        if (result.status == 200) {
          this.lstFuncoes =  result.data.data;
        }
      });
    },

    salvar() {
      this.$root.$loading.set(true);
      this.response = {};

      this.$root.$request
        .post(
          "/ltcat/ghe/funcionario/" + this.parent.formData.id + "/editar",
          this.formData
        )
        .then((result) => {
          this.$root.$loading.set(false);
          this.response = result;

          if (result.status == 200) {
            this.$root.$dialog.alert("Dados atualizados");
            this.showFormEdit = !this.showFormEdit;
            this.getLtcatFuncionario();
          }
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// funcionario.vue?70d5d174